<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<ng-template #profileModalView
             let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <ng-container *ngTemplateOutlet="profileContent"></ng-container>
    </div>
</ng-template>

<div *ngIf="modalView===false">
    <ng-container *ngTemplateOutlet="profileContent"></ng-container>
</div>

<ng-template #profileContent>
    <div *ngIf="profile else loading"
         [style.margin-top]="modalView? '20px' : '0'">
        <h1>{{ 'PROFILE_MODAL.USER_PROFILE' | translate }} {{ profile.lastname }} {{ profile.firstname }}</h1>
        <div *ngIf="profile"
             class="row align-items-center">
            <div class="col-5">
                <div class="profile-avatar">
                    <app-avatar [profile]="profile"
                                [size]="'full'"
                                [detailProfile]="true"
                    ></app-avatar>
                </div>
            </div>
            <div class="col-7 main_info info">
                <h2>{{ 'PROFILE_MODAL.TITLE' | translate }}</h2>
                <p><b>{{ 'PROFILE_MODAL.SECOND_NAME' | translate }}
                    :</b> {{ profile.lastname ? profile.lastname : '-' }}
                </p>
                <p><b>{{ 'PROFILE_MODAL.NAME' | translate }}: </b> {{ profile.firstname ? profile.firstname : '-' }}
                </p>
                <p *ngIf="profile.middlename"><b>{{ 'PROFILE_MODAL.MIDDLENAME' | translate }}
                    :</b> {{ profile.middlename }}</p>
                <p><b>{{ 'PROFILE_MODAL.EMAIL' | translate }}:</b> {{ profile.email ? profile.email : '-' }}</p>
                <p><b>{{ 'PROFILE_MODAL.PHONE' | translate }}:</b> {{ profile.phone ? profile.phone : '-' }}</p>
                <p><b>{{ 'PROFILE_MODAL.ROLE' | translate }}
                    :</b> {{ 'USER_PROFILE.ROLE.' + profile.project_setting.observation_type | translate }}
                <p>
                    <b>{{ 'PROFILE_MODAL.POSITION' | translate }}:</b>
                    {{ profile.project_setting.position ? profile.project_setting.position : '-' }}
                </p>
                <p>
                    <b>{{ 'PROFILE_MODAL.LAST_ACTIVE' | translate }}:</b>
                    {{
                        profile.project_setting.last_request ? helper.formatDate(profile.project_setting.last_request) :
                            ('PROFILE_MODAL.NO_DATA' | translate)
                    }}
                </p>
                <p><b>{{ 'PROFILE_MODAL.JOIN' | translate }}:</b>
                    {{
                        profile.project_setting.join_date ? helper.formatDate(profile.project_setting.join_date) :
                            ('PROFILE_MODAL.NO_DATA' | translate)
                    }}
                </p>
            </div>
        </div>
    </div>
</ng-template>
